<template>
  <div class="my-layout-box ">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :buttonList="buttonList"
      @onSeeDetail="onSeeDetail"
      :placeholderTitle="placeholderTitle"
      :listMap="listMap">
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { itemsData } from "./config";
import { getPaymentApply } from "~/api/finance";
export default {
  name: "PaymentApplyView",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: false,
      isButtonShow: true,
      listMap: itemsData,
      buttonList: [
        {title: '查看详情'}
      ],
      placeholderTitle: '请输入付款单号'
    };
  },

  methods: {
    async getList(pagination, searchData) {
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };
      sendData.Code = searchData.value;
      const list = await getPaymentApply(sendData);
      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    },
     onSeeDetail(items) {
      const { Id } = items;
      this.$router.push({
        name: 'paymentApplyDetail',
        query: {
          id: Id
        }
      });
    }
  }
};
</script>

<style lang="less" scope></style>
